import { POST_FLIGHT_DOUBLE_DOWN_TASK_TYPE, PREFLIGHT_REPORT_TASK_TYPE } from "@nexus/contracts";

/**
 * Adge "Generate for tenants": one card per receiving tenant, pointing at the set
 * the BFF created for it. Mirrors the literal in `services/api/src/routes/scripts-broadcast.ts`.
 */
export const SCRIPTS_BROADCAST_TASK_TYPE = "scripts-broadcast";

/** Task types whose navigation already points at a ready set on the Scripts tab. */
const SCRIPTS_TAB_TASK_TYPES = new Set([
  "generate-persona-scripts",
  SCRIPTS_BROADCAST_TASK_TYPE,
  POST_FLIGHT_DOUBLE_DOWN_TASK_TYPE,
  "generate-persona-storyboard",
  "ai-edit-persona-scripts",
  "ai-edit-persona-briefs",
  "generate-persona-hook-variations",
  "import-persona-script",
  "generate-scripts",
  "ai-edit-scripts",
]);

/** Keep setId + tab params while these jobs are still running. */
export function keepsScriptsTabParams(type: string): boolean {
  return SCRIPTS_TAB_TASK_TYPES.has(type);
}

/**
 * Task types whose navigation target exists — and is worth opening — from the
 * moment the job starts, so their params survive the running state. A Pre-Flight
 * report row is created before the first creative is scored, and its page renders
 * the in-progress state.
 */
const LIVE_TARGET_TASK_TYPES = new Set([PREFLIGHT_REPORT_TASK_TYPE]);

/** Whether a running task should navigate with its params intact. */
export function keepsNavigationParams(type: string): boolean {
  return keepsScriptsTabParams(type) || LIVE_TARGET_TASK_TYPES.has(type);
}

/** @deprecated Use keepsScriptsTabParams */
export const keepsPersonaScriptsTabParams = keepsScriptsTabParams;
